<script>
export default {
  name: "HeaderPage",
  methods: {
    goHome() {
      this.$router.push("/").catch((err) => {
        if (err.name !== "NavigationDuplicated") {
          throw err;
        }
      });
    },
  },
};
</script>

<template>
  <div class="header-wrapper">
    <div class="header-left">
      <span class="logo" @click="goHome">
        <span class="logo-icon">⚡</span>
        <span class="logo-text">commit.fun</span>
      </span>
    </div>
    <div class="header-right"></div>
  </div>
</template>

<style scoped>
.header-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 60px;
  padding: 0 30px;
  background-color: #0f1115;
}

.header-left {
  display: flex;
  align-items: center;
}

.logo {
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: opacity 0.25s ease;
}

.logo:hover {
  opacity: 0.85;
}

.logo-icon {
  font-size: 20px;
  margin-right: 10px;
}

.logo-text {
  font-size: 20px;
  font-weight: 600;
  color: #f2f2f2;
  letter-spacing: 0.5px;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 20px;
}

.header-link {
  color: #9ca3af;
  font-size: 14px;
  cursor: pointer;
  transition: color 0.25s ease;
  padding: 8px 16px;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.header-link:hover {
  color: #63a278;
  border-color: rgba(99, 162, 120, 0.4);
  background-color: rgba(99, 162, 120, 0.1);
}
</style>
